export default "__VITE_ASSET__DI5SOfFA__"